export default "__VITE_ASSET__4e7dd599__"